import { render } from "./BenefitItem.vue?vue&type=template&id=3f344da8&scoped=true"
import script from "./BenefitItem.vue?vue&type=script&lang=js"
export * from "./BenefitItem.vue?vue&type=script&lang=js"

import "./BenefitItem.vue?vue&type=style&index=0&id=3f344da8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f344da8"]])

export default __exports__